import { Col, Row, Space } from 'antd'
import { FC } from 'react'

import { BitazzaText } from '../../../../../components'
import Styles from './CumulativePerformance.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    cumulativePerf: performanceRequestData
}
export const CumulativePerformance: FC<Props> = ({ cumulativePerf }) => {
    console.log(cumulativePerf, 'cumulativePerf')
    const { t } = useTranslation()
    const DATA = [
        { label: '1D', value: cumulativePerf['1D_change_pct'] },
        {
            label: '7D',
            value: cumulativePerf['1W_change_pct'],
        },
        { label: '30D', value: cumulativePerf['1M_change_pct'] },
        // { label: '90D', value: cumulativePerf['3M_change_pct'] },
        { label: t('txt_all_time'), value: cumulativePerf.since_inception_pct },
    ]
    return (
        <div className={Styles.container}>
            <BitazzaText
                content={t('txt_cumulative_prf')}
                format="t16"
                letterSpacing={2}
                color="#86A1A1"
                bold
                lineHeight={32}
            />

            <Row className={Styles.wrapper} justify="center" wrap={false}>
                {/* eslint-disable-next-line array-callback-return */}
                {DATA.map((data) => {
                    return (
                        <Col
                            span={6}
                            key={data.label}
                            className={Styles.containerNumber}
                        >
                            <Space direction="vertical" size={0} align="center">
                                <BitazzaText
                                    content={data.label}
                                    format="t16"
                                    color="#86A1A1"
                                    noWrap
                                />

                                <BitazzaText
                                    content={
                                        data.value
                                            ? data.value?.toFixed(2) + '%'
                                            : 'N/A'
                                    }
                                    format="t16"
                                    color={
                                        !data.value
                                            ? 'rgb(134, 161, 161)'
                                            : data.value > 0
                                            ? '#10F48B'
                                            : '#EF4150'
                                    }
                                />
                            </Space>
                        </Col>
                    )
                })}
            </Row>
        </div>
    )
}
